import React from 'react'

const TRXUSD = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='49' viewBox='0 0 48 49' fill='none'>
      <rect x='0.5' y='0.765625' width='47' height='47' rx='23.5' fill='white' />
      <rect x='0.5' y='0.765625' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
      <path
        d='M37.6055 20.4979C36.2245 19.2228 34.3142 17.2756 32.7583 15.8946L32.6663 15.8302C32.5131 15.7072 32.3404 15.6107 32.1553 15.5448C28.4037 14.8451 10.9438 11.5814 10.6032 11.6228C10.5077 11.6362 10.4165 11.6708 10.3362 11.7241L10.2487 11.7931C10.141 11.9025 10.0592 12.0347 10.0093 12.1798L9.98633 12.2397V12.5665V12.6171C11.9519 18.0904 19.7129 36.02 21.2411 40.2274C21.3332 40.5128 21.5081 41.056 21.835 41.0836H21.9086C22.0835 41.0836 22.8292 40.0985 22.8292 40.0985C22.8292 40.0985 36.1601 23.9319 37.5088 22.2103C37.6834 21.9982 37.8375 21.7701 37.9691 21.529C38.0027 21.3404 37.9869 21.1462 37.9232 20.9655C37.8594 20.7848 37.75 20.6237 37.6055 20.4979ZM26.2494 22.3806L31.939 17.6623L35.2763 20.7372L26.2494 22.3806ZM24.0399 22.0722L14.2443 14.0441L30.0931 16.9672L24.0399 22.0722ZM24.9237 24.1759L34.9495 22.5601L23.4875 36.3699L24.9237 24.1759ZM12.914 14.8451L23.2205 23.5913L21.7291 36.3791L12.914 14.8451Z'
        fill='#FF060A'
      />
    </svg>
  )
}

export default TRXUSD
